import { useState } from "react";
import { Copy } from "lucide-react";
import SearchableSelect from "./SearchableSelect";
import "./CopyBillingAddress.css";

type BillingAddress = {
  address_id: string; label: string; address_line1: string; city: string; postal_code: string; default_address: boolean;
};

export function CopyBillingAddress<T extends BillingAddress>({ addresses, disabled = false, onCopy, buttonLabel = "Copy billing address" }: {
  addresses: T[]; disabled?: boolean; onCopy: (address: T) => void; buttonLabel?: string;
}) {
  const [choice, setSelectedId] = useState<string | null>(null);
  const selectedId = choice ?? addresses.find(address => address.default_address)?.address_id
    ?? (addresses.length === 1 ? addresses[0].address_id : "");
  const selected = addresses.find(address => address.address_id === selectedId);
  if (!addresses.length) return null;
  const options = addresses.map(address => ({ value: address.address_id, label: address.label,
    description: [address.address_line1, address.city, address.postal_code].filter(Boolean).join(", ") }));
  return <div className="address-copy-controls">
    {addresses.length > 1 && <div className="address-copy-choice">{addresses.length > 4 ? <SearchableSelect label="Billing address to copy" value={selectedId} onChange={setSelectedId}
      options={options} placeholder="Choose a billing address" searchPlaceholder="Search billing addresses" emptyMessage="No matching billing addresses." disabled={disabled} /> : <select aria-label="Billing address to copy" value={selectedId} disabled={disabled} onChange={event => setSelectedId(event.target.value)}>
        <option value="" disabled>Choose a billing address</option>
        {options.map(option => <option key={option.value} value={option.value}>{option.label} — {option.description}</option>)}
      </select>}</div>}
    <button type="button" className="pa-secondary-button" disabled={disabled || !selected}
      onClick={() => { if (selected) onCopy(selected); }}><Copy size={15} aria-hidden="true" />{buttonLabel}</button>
  </div>;
}
